import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getBrand, resetBrandState } from "../../../store/brand/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetEmployeeLocationState, getEmployeeLocation as onGetEmployeeLocations, addNewEmployeeLocation as onAddNewEmployeeLocation, updateEmployeeLocation as onUpdateEmployeeLocation, deleteEmployeeLocation as onDeleteEmployeeLocation, getEmployeeLocationLoading } from "../../../store/employeeLocation/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import Leaflet from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { useRef } from "react";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";
let DefaultIcon = Leaflet.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
Leaflet.Marker.prototype.options.icon = DefaultIcon;

const EmployeeLocation = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, companies, companyLoading, employeeLocations, isEmployeeLocationCreated, isEmployeeLocationSuccess, loading, error, brands, brandLoading, branches, branchLoading, employees, employeeLoading, positions, positionLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    employeeLocations: state.EmployeeLocation.employeeLocations,
    isEmployeeLocationCreated: state.EmployeeLocation.isEmployeeLocationCreated,
    isEmployeeLocationSuccess: state.EmployeeLocation.isEmployeeLocationSuccess,
    loading: state.EmployeeLocation.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    error: state.EmployeeLocation.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
  }));

  const [employeeLocationList, setEmployeeLocationList] = useState([]);
  const [employeeLocation, setEmployeeLocation] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isNewLocation, setIsNewLocation] = useState(false);
  const [info, setInfo] = useState([]);
  const [locationCord, setLocationCord] = useState([0, 0]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [inlocation, setInlocation] = useState([]);
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const reasonData = [
    {
      options: [
        { label: "Lokasi Karyawan Baru", value: "New Work Location" },
        { label: "Rotasi Karyawan", value: "Employee Rotation" },
        { label: "Mutasi Karyawan", value: "Employee Mutation" },
      ],
    },
  ];
  const multioptions = [{ label: "Select All", value: "all" }];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (employeeLocation) => {
    setEmployeeLocation(employeeLocation);
    setDeleteModal(true);
  };

  const handleDeleteEmployeeLocation = () => {
    if (employeeLocation) {
      dispatch(onDeleteEmployeeLocation(employeeLocation));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(employeeLocations)) {
      setEmployeeLocationList(employeeLocations);
      setInfo(employeeLocations[employeeLocations.length - 1]);
      setLocationCord([employeeLocations[employeeLocations.length - 1].location_branch && employeeLocations[employeeLocations.length - 1].location_branch.latitude ? employeeLocations[employeeLocations.length - 1].location_branch.latitude : 0, employeeLocations[employeeLocations.length - 1].location_branch && employeeLocations[employeeLocations.length - 1].location_branch.longitude ? employeeLocations[employeeLocations.length - 1].location_branch.longitude : 0]);
    }
    else {
      setEmployeeLocationList([]);
    }
  }, [employeeLocations]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredEmployeeLocations = employeeLocations;
      if (type !== "all") {
        filteredEmployeeLocations = employeeLocations.filter((employeeLocation) => employeeLocation.location_status.name === type);
      }
      setEmployeeLocationList(filteredEmployeeLocations);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetEmployeeLocationState());
      dispatch(onGetEmployeeLocations({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(userData?.companyId);
      handleGetPosition(userData?.companyId);
    }
  }, [companySelected]);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  const handleGetPosition = (id) => {
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(employeeLocations)) {
      let filteredEmployeeLocations = employeeLocations;
      if (activeTypeTab !== "all") {
        filteredEmployeeLocations = employeeLocations.filter((employeeLocation) => employeeLocation.location_status.name === activeTypeTab);
      }
      setEmployeeLocationList(filteredEmployeeLocations.map((el) => ({ ...el, isChecked: false })));
    }
  }, [employeeLocations]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "location_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "location_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "isPrimary",
        label: "Primary",
        isSelected: true,
        data: [],
      },
    ];

    if (employeeLocationList.length > 0) {
      employeeLocationList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "location_user" || doc.id === "location_branch") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "isPrimary") {
                doc.data.push(value ? "Primary" : "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [employeeLocationList]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const departement_name = item.position_department && item.position_department && item.position_department.name;
        const id = item.id;
        var obj = { label: `${position_name}, ${departement_name}`, value: id, departmentId: departmentId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const position = item?.employee_user?.user_position && item?.employee_user?.user_department ? { label: `${item?.employee_user?.user_position?.name}, ${item?.employee_user?.user_department?.name}`, value: item?.employee_user?.user_position?.id, departmentId: item?.employee_user?.user_department?.id } : "";
      var obj = { label: name, value: id, position: position };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handleEmployeeLocationInfoClick = (data) => {
    setLocationCord([data.location_branch && data.location_branch.latitude ? data.location_branch.latitude : 0, data.location_branch && data.location_branch.longitude ? data.location_branch.longitude : 0]);
    setInfo(data);
  };

  const handleEmployeeLocationClick = useCallback(
    (arg) => {
      const data = arg;
      if (data.reason !== "New Work Location") {
        setIsNewLocation(true);
      } else {
        setIsNewLocation(false);
      }

      setEmployeeLocation({
        id: data.id,
        positionChangeId: data.positionChangeId ? data.positionChangeId : "",
        description: data.description,
        startat: data.startat,
        promotion: data.promotion === null ? "" : data.promotion,
        isPrimary: data.isPrimary,
        reason: { label: data.reason, value: data.reason },
        employee: data.location_user && {
          label: data.location_user ? data.location_user.name : "",
          value: data.location_user ? data.location_user.id : "",
          position: data.location_user.user_position && data.location_user?.user_department ? { label: `${data.location_user.user_position.name}, ${data.location_user?.user_department?.name}`, value: data.location_user.user_position.id, departmentId: data.location_user?.user_department?.id } : "",
        },
        oldposition: data.location_position_change === null ? "" : { label: `${data.location_position_change.oldPosition_name}, ${data.location_position_change.oldDepartment_name}`, value: data.location_position_change.oldPositionId, departmentId: data.location_position_change.oldDepartmentId },
        position: data.location_position_change === null ? "" : { label: `${data.location_position_change.position_name}, ${data.location_position_change.department_name}`, value: data.location_position_change.positionId, departmentId: data.location_position_change.departmentId },
        company: data.location_company && {
          label: data.location_company ? data.location_company.name : "",
          value: data.location_company ? data.location_company.id : "",
        },
        client: data.location_client && {
          label: data.location_client ? data.location_client.name : "",
          value: data.location_client ? data.location_client.id : "",
        },
        branch: data.location_branch && {
          label: data.location_branch ? data.location_branch.name : "",
          value: data.location_branch ? data.location_branch.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, dispatch, userType]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployeeLocation(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setEmployeeLocation(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (employeeLocation) {
      employeeLocation.setApprove = true;
      dispatch(onUpdateEmployeeLocation(employeeLocation));
      dispatch(resetEmployeeLocationState());
      dispatch(onGetEmployeeLocations());
      setApproveModal(false);
    }
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = employeeLocationList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setEmployeeLocationList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = employeeLocationList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setEmployeeLocationList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      handleEmployeeLocationInfoClick(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateEmployeeLocation") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleEmployeeLocationClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteEmployeeLocation") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEmployeeLocation") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "location_user.name",
        filterable: true,
      },
      {
        Header: "Cabang",
        accessor: "location_branch.name",
        filterable: true,
      },
      {
        Header: "Primary",
        accessor: "isPrimary",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case false:
              return "";
            default:
              return <span className="badge text-uppercase badge-soft-success"> Primary </span>;
          }
        },
      },
      {
        Header: "Status",
        accessor: "location_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [employeeLocationList, handleEmployeeLocationClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = employeeLocationList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setEmployeeLocationList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => employeeLocationList, [employeeLocationList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetEmployeeLocations(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEmployeeLocationList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetEmployeeLocationState());
    dispatch(onGetEmployeeLocations({ companyId: companySelected?.value ?? "" }));
  };

  function handleReason(e) {
    validation.setFieldValue("reason", e);
    if (e.value === "New Work Location") {
      setIsNewLocation(false);
    } else {
      setIsNewLocation(true);
      validation.setFieldValue("employee", null);
      validation.setFieldValue("branch", null);
      validation.setFieldValue("brand", null);
    }
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (employeeLocation && employeeLocation.description) ?? "",
      address: (employeeLocation && employeeLocation.address) ?? "",
      promotion: (employeeLocation && employeeLocation.promotion) ?? "",
      isPrimary: (employeeLocation && employeeLocation.isPrimary) || false,
      branch: (employeeLocation && employeeLocation.branch) ?? "",
      startat: (employeeLocation && employeeLocation.startat) ?? "",
      client: (employeeLocation && employeeLocation.client) || clientSelected,
      company: (employeeLocation && employeeLocation.company) || companySelected,
      employee: (employeeLocation && employeeLocation.employee) ?? "",
      reason: (employeeLocation && employeeLocation.reason) ?? "",
      position: (employeeLocation && employeeLocation.position) ?? "",
      oldposition: (employeeLocation && employeeLocation.oldposition) ?? "",
      inlocation: (employeeLocation && employeeLocation.inlocation) ?? "",
      deffective_location: (employeeLocation && employeeLocation.deffective_location) || [],
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Please Enter Branch").nullable(true),
      employee: Yup.object().required("Please Enter Employee").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getEmployeeLocationLoading());
      if (isEdit) {
        const updateEmployeeLocation = {
          id: employeeLocation ? employeeLocation.id : 0,
          statusId: 1,
          description: values.description,
          branchId: values.branch.value,
          location: values.inlocation,
          startat: values.startat,
          reason: values.reason.value,
          isPrimary: values.isPrimary,
          promotion: values.promotion,
          userId: values.employee.value,
          clientId: values.client.value,
          companyId: values.company.value,
          deffective_location: values.deffective_location,
          name: values.position.name,
          positionId: values.position.value,
          position_name: values.position.label ? values.position.label.split(",")[0] : null,
          departmentId: values.position.departmentId,
          department_name: values.position.label ? values.position.label.split(",")[1] : null,
          oldDepartmentId: values.oldposition.departmentId,
          oldDepartment_name: values.oldposition.label ? values.oldposition.label.split(",")[1] : null,
          oldPositionId: values.oldposition.value,
          oldPosition_name: values.oldposition.label ? values.oldposition.label.split(",")[0] : null,
        };
        dispatch(onUpdateEmployeeLocation(updateEmployeeLocation));
        validation.resetForm();
      } else {
        const newEmployeeLocation = {
          statusId: 1,
          description: values.description,
          branchId: values.branch.value,
          location: values.inlocation,
          startat: values.startat,
          reason: values.reason.value,
          isPrimary: values.isPrimary,
          promotion: values.promotion,
          userId: values.employee.value,
          clientId: values.client.value,
          companyId: values.company.value,
          deffective_location: values.deffective_location,
          name: values.position.name,
          positionId: values.position.value,
          position_name: values.position.label ? values.position.label.split(",")[0] : null,
          departmentId: values.position.departmentId,
          department_name: values.position.label ? values.position.label.split(",")[1] : null,
          oldDepartmentId: values.oldposition.departmentId,
          oldDepartment_name: values.oldposition.label ? values.oldposition.label.split(",")[1] : null,
          oldPositionId: values.oldposition.value,
          oldPosition_name: values.oldposition.label ? values.oldposition.label.split(",")[0] : null,
        };

        dispatch(onAddNewEmployeeLocation(newEmployeeLocation));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Lokasi Kerja | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={employeeLocationList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployeeLocation} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={employeeLocation && employeeLocation.location_branch && employeeLocation.location_employee ? employeeLocation.location_employee.name + " - " + employeeLocation.location_branch.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Karyawan" pageTitle="Lokasi Kerja" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createEmployeeLocation") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-hotel-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteEmployeeLocation") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-hotel-line me-1 align-bottom fs-14"></i>SEMUA LOKASI KERJA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={reasonData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Lokasi Kerja" : "Tambah Lokasi Kerja"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="active-reason" className="form-label">
                              Alasan
                            </Label>
                            <Select
                              name="reason"
                              placeholder="Pilih Alasan"
                              value={validation.values.reason}
                              onChange={(e) => {
                                handleReason(e);
                              }}
                              options={reasonData}
                              invalid={validation.touched.employee && validation.errors.employee ? true : false}
                            ></Select>
                            {validation.touched.reason && validation.errors.reason ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.reason}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="employee-field" className="form-label">
                              Karyawan <span className="text-danger">*</span>&nbsp;
                              {employeeLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="employee"
                              value={validation.values.employee}
                              placeholder="Pilih Karyawan"
                              isDisabled={employeeList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("oldposition", e.position);
                                validation.setFieldValue("employee", e);
                              }}
                              options={employeeList}
                            ></Select>
                            {validation.touched.employee && validation.errors.employee ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.employee}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="branch-field" className="form-label">
                              Cabang <span className="text-danger">*</span>&nbsp;
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Perusahaan"
                              onChange={(e) => {
                                dispatch(setBranchSelect(e));
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.branch}
                              </p>
                            ) : null}
                          </div>
                          {!!isNewLocation ? (
                            <div>
                              <p className="fw-medium">Apakah lokasi baru terkait dengan promosi atau penurunan pangkat?</p>
                              <div className="mb-3">
                                <div className="form-check mb-3">
                                  <Input className="form-check-input" value="None" type="radio" name="promotion" id="radioPromotion1" checked={validation.values.promotion === "None" || validation.values.promotion === "" || validation.values.promotion === null} onChange={validation.handleChange} />
                                  <Label className="form-check-label" for="radioPromotion1">
                                    Tidak ada promosi - penurunan pangkat
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input className="form-check-input" value="Promotion" type="radio" name="promotion" id="radioPromotion2" checked={validation.values.promotion === "Promotion"} onChange={validation.handleChange} />
                                  <Label className="form-check-label" for="radioPromotion2">
                                    promosi
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input className="form-check-input" value="Demotion" type="radio" name="promotion" id="radioPromotion3" checked={validation.values.promotion === "Demotion"} onChange={validation.handleChange} />
                                  <Label className="form-check-label" for="radioPromotion3">
                                    penurunan pangkat
                                  </Label>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <p className="fw-medium">Apakah lokasi merupakan lokasi kerja utama?</p>
                            <Input name="isPrimary" id="isPrimary-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isPrimary} /> &nbsp;
                            <Label htmlFor="isPrimary-field" className="form-label">
                              Lokasi Utama
                            </Label>
                          </div>

                          {!!isNewLocation ? (
                            <div>
                              <div className="mb-3">
                                <Label htmlFor="oldposition" className="form-label">
                                  Posisi Lama
                                </Label>
                                <Select name="oldposition" placeholder="Enter Current Position" isDisabled={true} value={validation.values.oldposition} invalid={validation.touched.oldposition && validation.errors.oldposition ? true : false}></Select>
                                {validation.touched.oldposition && validation.errors.oldposition ? (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.oldposition}
                                  </small>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="position" className="form-label">
                                  Posisi Baru (Jika berubah)
                                  {positionLoading ? (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  ) : (
                                    ""
                                  )}
                                </Label>
                                <Select
                                  name="position"
                                  placeholder="Enter New Position"
                                  value={validation.values.position}
                                  onChange={(e) => {
                                    validation.setFieldValue("position", e);
                                  }}
                                  options={positionList}
                                  invalid={validation.touched.position && validation.errors.position ? true : false}
                                ></Select>
                                {validation.touched.position && validation.errors.position ? (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.position}
                                  </small>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="inlocation" className="form-label">
                                  Lokasi lama yang deaktif
                                </Label>
                                <Select
                                  name="inlocation"
                                  isMulti
                                  value={validation.values.inlocation}
                                  placeholder="Enter Deactive Position"
                                  onChange={(opt, { option }) => {
                                    let newOpts = !!isEdit ? [] : opt;
                                    if (option && option.value === "all") {
                                      let filteredOptions = clone(inlocation);
                                      filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                      newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                    }
                                    validation.setFieldValue("inlocation", newOpts);
                                  }}
                                  options={inlocation}
                                ></Select>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3">
                            <Label htmlFor="date-field" className="form-label">
                              Tanggal Berlaku
                            </Label>
                            <Flatpickr
                              name="startat"
                              className="form-control"
                              placeholder="Pilih Tanggal"
                              options={{ enableTime: false, dateFormat: "Y/m/d" }}
                              value={validation.values.startat ?? ""}
                              onChange={(o, e) => {
                                validation.setFieldValue("startat", e);
                              }}
                            />
                            {validation.touched.startat && validation.errors.startat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.startat}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-4">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="deffective_location" type="hidden" value={validation.values.deffective_location ?? ""} />
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <CardBody className="text-center">
                <MapContainer center={[-6.8429174, 107.5710306]} zoom={9} style={{ height: "200px" }}>
                  <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={locationCord}>
                    <Popup>{info.location_branch && info.location_branch.name ? info.location_branch.name : "-"}</Popup>
                  </Marker>
                </MapContainer>
              </CardBody>
              <div className="card-body">
                <h6 className="text-muted text-uppercase fw-semibold mb-2">Informasi</h6>
                <p className="text-muted mb-4">{info.description ? info.description : "-"} </p>
                <div className="table-card p-2">
                  <table className="table table-responsive table-striped">
                    <tbody>
                      <tr>
                        <td className="p-2">Alasan</td>
                        <td className="p-2">{info.reason ? info.reason : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info.location_company && info.location_company.name ? info.location_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Cabang</td>
                        <td className="p-2">{info.location_branch && info.location_branch.name ? info.location_branch.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Promosi</td>
                        <td className="p-2">{info.promotion && info.promotion ? info.promotion : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Longitude</td>
                        <td className="p-2">{info.location_branch && info.location_branch.longitude ? info.location_branch.longitude : "0"} </td>
                      </tr>
                      <tr>
                        <td className="p-2"> Latitude</td>
                        <td className="p-2">{info.location_branch && info.location_branch.latitude ? info.location_branch.latitude : "0"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.location_createdby && info.location_createdby.name ? info.location_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.location_updatedby && info.location_updatedby.name ? info.location_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Disetujui Oleh</td>
                        <td className="p-2">{info.location_approvedby && info.location_approvedby.name ? info.location_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EmployeeLocation;
